import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';
import toastService from '../../../services/toastService';

class VIGeneralDrawingForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		initialGeneralDrawing: PropTypes.array,
		onProceed: PropTypes.func,
	};

	schema = {
		generalDrawing: Joi.array().min(1).max(1).required().label('General Drawing'),
	};

	componentDidMount() {
		if (this.props.initialGeneralDrawing) {
			this.setState({ data: { generalDrawing: this.props.initialGeneralDrawing }});
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.generalDrawing);
		toastService.success('General Drawing Saved Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 1,
					multiple: false,
					name: 'generalDrawing',
					accept: 'image/*,application/pdf',
					label: 'General Drawing',
					sublabel: 'Upload General Drawing',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

const initialData = { generalDrawing: [] };
export default VIGeneralDrawingForm;
